module.exports = __webpack_public_path__ + "img/lineaaspera.7957eabd.jpg";